import styled from '@emotion/styled';
import {
  Breadcrumb,
  Button,
  Card,
  Form,
  Image,
  Input,
  Space,
  notification,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FaCalendar, FaHome, FaLink, FaPodcast } from 'react-icons/fa';
import { FiChevronRight } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { ConnectedUserEntity } from '../../../entities/ConnectedUserEntity';
import { createForums } from '../../../redux/userStore/actions';
import {
  commentType,
  forumType,
  postType,
} from '../../../redux/userStore/reducer';
import { ROUTES } from '../../../routes';
import { ORANGE, PRIMARY, YELLOW } from '../../../shared/colors';
import { forumNetwork } from '../../dashboard/network';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import Loading from '../../shared/Loading';
import { NothingFound } from '../../template/NothingFound';
import { getPost, getPostsByCats } from '../components/api';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-color: white;
    background-image: url('/assets/images/formation-banner.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 5% 15% 5% 15%;

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 13px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  .top-box {
    min-height: 400px;
    background-color: #e0e0e0;
    color: grey;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    padding-top: 50px;

    p {
      font-size: 16px;
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > div {
      //display: flex;
      flex-wrap: wrap;
      // background-color: green;
    }
  }
`;

export const Forum = () => {
  const history = useHistory();
  const { forums: FORUMS } = useSelector((state: any) => state.userReducer);
  // const connectedUser: ConnectedUserEntity = user;
  // const countSub = async (index: number) => {
  //   return getPostsByCats(index);
  // };

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Forum
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.HOME_PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Forum</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {FORUMS?.map((form: forumType, i: number) => (
              <p key={i} onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}>
                {form.fields.topic}
              </p>
            ))}
          </div> */}
        </div>

        <div className='content'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <h2 style={{ marginBottom: 0 }}>Liste des Forums </h2>
            <Space size={40} />
            &nbsp;&nbsp;
            <div
              style={{
                fontFamily: 'Poppins-B',
                fontSize: 35,
              }}
            >
              <span style={{ color: ORANGE }}>Moranj</span>
              <span style={{ color: '#6d4c41' }}>E</span>
              <span style={{ color: YELLOW }}>trade</span>
            </div>
          </div>

          {FORUMS?.map((form: forumType, i: number) => (
            <Card
              bordered={false}
              title={
                <h4
                  style={{ cursor: 'pointer' }}
                  onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}
                >
                  <FiChevronRight style={{ marginBottom: -2.5 }} />{' '}
                  {form.fields.topic}
                </h4>
              }
            >
              <p className='twolines'>{form.fields.description}</p>
              <div
                style={{
                  float: 'right',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                <Button type='text'>
                  {form.fields.count} posts &nbsp;&nbsp;
                  <FaPodcast /> &nbsp;&nbsp;
                </Button>
                <Button
                  type='link'
                  onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}
                >
                  Voir &nbsp;&nbsp;
                  <FaLink />
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
export const Categorie = () => {
  const { catId }: { catId: string } = useParams();
  const { user, forums: FORUMS } = useSelector(
    (state: any) => state.userReducer,
  );
  const connectedUser: ConnectedUserEntity = user;
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [posts, setPosts] = useState<postType[]>([]);
  const handleError = (err: Error) => {
    notification.error({
      message: 'Erreur',
      description: err.message,
    });
    setLoading(false);
  };
  const countSub = async () => {
    setLoading(true);
    const r = await getPostsByCats(connectedUser.id, catId);
    if (r.status === false) throw Error(r.message);
    setLoading(false);
    return r;
  };

  useEffect(() => {
    countSub().then(setPosts).catch(handleError);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    countSub().then(setPosts).catch(handleError);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catId]);

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='/assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Forum
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.HOME_PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.FORUM.PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <span>Forum</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                {
                  FORUMS?.filter((e: forumType) => e.pk === catId).at(0)?.fields
                    .topic
                }
              </span>
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* 
<div className='menus'>
            {FORUMS?.map((form: forumType, i: number) => (
              <p key={i} onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}>
                {form.fields.topic}
              </p>
            ))}
          </div> */}
        </div>

        <div className='content'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingBottom: 50,
            }}
          >
            <h2>
              {
                FORUMS?.filter((e: forumType) => e.pk === catId).at(0)?.fields
                  .topic
              }
            </h2>{' '}
            <Button
              className='active'
              style={{
                backgroundColor: ORANGE,
                borderColor: '#6d4c41',
                color: '#ffffff',
                borderWidth: 1,
              }}
              onClick={() => history.push(ROUTES.FORUM.POSTSUBJET(catId))}
            >
              Poster un sujet
            </Button>
          </div>
          {isLoading && <Loading />}
          {!isLoading && posts.length === 0 && <NothingFound />}
          {!isLoading && (
            <div>
              {posts.map((form, i) => (
                <Card
                  bordered={false}
                  title={
                    <h4
                      style={{ cursor: 'pointer', margin: 0 }}
                      onClick={() => history.push(ROUTES.FORUM.POST(form.pk))}
                    >
                      <FiChevronRight style={{ marginBottom: -2.5 }} />{' '}
                      {form.fields.title}
                    </h4>
                  }
                >
                  {form.fields.content}
                </Card>
              ))}
            </div>
          )}
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
type LayoutType = Parameters<typeof Form>[0]['layout'];
export const ForumPost = () => {
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const { postId }: { postId: string } = useParams();
  const { user, forums: FORUMS } = useSelector(
    (state: any) => state.userReducer,
  );
  const connectedUser: ConnectedUserEntity = user;
  const [isLoading, setLoading] = useState(false);
  const [post, setPost] = useState<postType>();
  const [comments, setComments] = useState<commentType[]>();
  const countSub = async () => {
    console.log({ postId });
    return getPost(connectedUser.id, postId);
  };

  useEffect(() => {
    countSub().then((e: { post: postType; comments: commentType[] }) => {
      setPost(e.post);
      setComments(e.comments);
    });
    return () => {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='/assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Forum
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.HOME_PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.FORUM.PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <span>Forum</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={
                  post?.fields?.forum
                    ? ROUTES.FORUM.TOPIC(post?.fields?.forum)
                    : '#'
                }
                style={{ textDecoration: 'underline' }}
              >
                <span>
                  {
                    FORUMS?.filter(
                      (e: forumType) => e.pk === post?.fields?.forum,
                    ).at(0)?.fields?.topic
                  }
                </span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>{post?.fields?.title}</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          {/*   <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {FORUMS?.map((form: forumType, i: number) => (
              <p key={i} onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}>
                {form.fields.topic}
              </p>
            ))}
          </div> */}
        </div>

        <div className='content'>
          <h2>
            {post?.fields?.title}
            <p className='small'>
              <FaCalendar />
              &nbsp;&nbsp;
              {moment(post?.fields?.created_at).format(
                'DD MMM YYYY [at] HH:mm',
              )}
            </p>
          </h2>
          <p>{post?.fields?.content}</p>
          <ul className='comments'>
            <h2>Commentaires</h2>
            {comments?.map((c: commentType) => (
              <>
                <h4>{c.fields.author}</h4>
                <li
                  key={c.pk}
                  className='chat-bubble'
                  style={{ width: '100%', padding: 3 }}
                >
                  {' '}
                  <img
                    src={`https://i.pravatar.cc/150?u=${c.fields.user}`}
                    alt='User 1 Avatar'
                  />
                  {c.fields.content}{' '}
                  <span className='timestamp'>
                    {moment(c.fields.created_at).format(
                      'DD MMM YYYY [at] HH:mm',
                    )}
                  </span>
                </li>
                {/* <Divider style={{ maxWidth: 350 }} /> */}
              </>
            ))}
          </ul>
          <Form
            layout={formLayout}
            style={{ listStyleType: 'none', width: '50%' }}
            form={form}
            labelCol={{ span: 20 }}
            wrapperCol={{ span: 25 }}
            onFinish={async (data) => {
              setLoading(true);
              const { content } = data;
              forumNetwork
                .postComment(connectedUser.id, postId, content)
                .then(async ({ statusCode, data }) => {
                  setLoading(false);
                  if (statusCode.toString()[0] === '2') {
                    form.resetFields();
                    countSub().then(
                      (e: { post: postType; comments: commentType[] }) => {
                        setPost(e.post);
                        setComments(e.comments);
                      },
                    );
                  } else {
                    notification.error({
                      message: 'Erreur',
                      description: data.message,
                    });
                    setLoading(false);
                  }
                })
                .catch((err) => {
                  notification.error({
                    message: 'Erreur',
                    description: err.message,
                  });
                  setLoading(false);
                });
            }}
          >
            <Form.Item
              label='Votre commentaire'
              name='content'
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Le commentaire est requis',
                },
              ]}
            >
              <TextArea placeholder='Entrer votre commentaire' />
            </Form.Item>

            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                size='large'
                loading={isLoading}
                style={{
                  width: '100%',
                  backgroundColor: ORANGE,
                  borderColor: PRIMARY,
                  borderWidth: 0,
                  marginBottom: 20,
                }}
              >
                Commenter
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
export const AddTopicForm = () => {
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const dispatch = useDispatch();
  const { user } = useSelector((state: any) => state.userReducer);
  const connectedUser: ConnectedUserEntity = user;
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const countSub = async () => {
    setLoading(true);
    return await forumNetwork
      .getHome(connectedUser.id)
      .then((e) => dispatch(createForums(e.data)))
      .catch((e) => {
        notification.error({
          message: 'Erreur',
          description: e.message,
        });
        setLoading(false);
      });
  };

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='/assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Forum
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.HOME_PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.FORUM.PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <span>Forum</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Ajouter un Forum</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {FORUMS?.map((form: forumType, i: number) => (
              <p key={i} onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}>
                {form.fields.topic}
              </p>
            ))}
          </div> */}
        </div>

        <div className='content'>
          <h2>Ajouter un Forum</h2>
          <Form
            layout={formLayout}
            style={{ listStyleType: 'none', width: '50%' }}
            form={form}
            labelCol={{ span: 20 }}
            wrapperCol={{ span: 25 }}
            onFinish={async (data) => {
              setLoading(true);
              const { topic, description } = data;
              forumNetwork
                .postTopic(connectedUser.id, description, topic)
                .then(async ({ statusCode, data }) => {
                  setLoading(false);
                  if (statusCode.toString()[0] === '2') {
                    form.resetFields();
                    await countSub();
                    history.push(ROUTES.FORUM.PAGE);
                  } else {
                    notification.error({
                      message: 'Erreur',
                      description: data.message,
                    });
                    setLoading(false);
                  }
                })
                .catch((err) => {
                  notification.error({
                    message: 'Erreur',
                    description: err.message,
                  });
                  setLoading(false);
                });
            }}
          >
            <Form.Item
              label='Theme ou nom de la categorie du Forum'
              name='topic'
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Le nom du forum est requis',
                },
              ]}
            >
              <Input placeholder='Entrer le nom du forum ici' />
            </Form.Item>
            <Form.Item
              label='Description du Forum'
              name='description'
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'La description du forum est requise',
                },
              ]}
            >
              <TextArea rows={10} placeholder='Entrer la description' />
            </Form.Item>

            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                size='large'
                loading={isLoading}
                style={{
                  width: '100%',
                  backgroundColor: ORANGE,
                  borderColor: PRIMARY,
                  borderWidth: 0,
                  marginBottom: 20,
                }}
              >
                Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
export const AddPostForm = () => {
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const dispatch = useDispatch();
  const { user, forums: FORUMS } = useSelector(
    (state: any) => state.userReducer,
  );
  const connectedUser: ConnectedUserEntity = user;
  const { topicId }: { topicId: string } = useParams();
  const [isLoading, setLoading] = useState(false);
  const countSub = async () => {
    return await forumNetwork
      .getHome(connectedUser.id)
      .then((e) => dispatch(createForums(e.data)))
      .catch((e) => {
        notification.error({
          message: 'Erreur',
          description: e.message,
        });
        setLoading(false);
      });
  };

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <Space size={10}>
            <Image
              alt='moranje-logo'
              src='/assets/images/moranje-logo.png'
              // height={250}
              width={130}
              preview={false}
              style={{ objectFit: 'contain', cursor: 'pointer' }}
            />
            <div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 35,
                }}
              >
                <span style={{ color: ORANGE }}>Moranj</span>
                <span style={{ color: '#6d4c41' }}>E</span>
                <span style={{ color: YELLOW }}>trade</span>
              </div>
              <div
                style={{
                  fontFamily: 'Poppins-B',
                  fontSize: 30,
                }}
              >
                Forum
              </div>
            </div>
          </Space>
          <Breadcrumb separator='>' className='bread-crumb'>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.HOME_PAGE}
                style={{ textDecoration: 'underline' }}
              >
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={ROUTES.FORUM.TOPIC(topicId)}
                style={{ textDecoration: 'underline' }}
              >
                <span>
                  {
                    FORUMS?.filter((e: forumType) => e.pk === topicId).at(0)
                      ?.fields.topic
                  }
                </span>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Poster un nouveau sujet</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          {/* <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

          <div className='menus'>
            {FORUMS?.map((form: forumType, i: number) => (
              <p key={i} onClick={() => history.push(ROUTES.FORUM.TOPIC(form.pk))}>
                {form.fields.topic}
              </p>
            ))}
          </div> */}
        </div>

        <div className='content'>
          <h2>Poster un nouveau sujet</h2>
          <Form
            layout={formLayout}
            style={{ listStyleType: 'none', width: '50%' }}
            form={form}
            labelCol={{ span: 20 }}
            wrapperCol={{ span: 25 }}
            onFinish={async (data) => {
              setLoading(true);
              const { title, content } = data;
              forumNetwork
                .postSubject(connectedUser.id, content, title, topicId)
                .then(async ({ statusCode, data }) => {
                  setLoading(false);
                  if (statusCode.toString()[0] === '2') {
                    form.resetFields();
                    countSub();
                  } else {
                    notification.error({
                      message: 'Erreur',
                      description: data.message,
                    });
                    setLoading(false);
                  }
                })
                .catch((err) => {
                  notification.error({
                    message: 'Erreur',
                    description: err.message,
                  });
                  setLoading(false);
                });
            }}
          >
            <Form.Item
              label='Titre du sujet'
              name='title'
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Le titre est requis',
                },
              ]}
            >
              <Input placeholder='Entrer le titre ici' />
            </Form.Item>
            <Form.Item
              label='Contenu du sujet de discussion'
              name='content'
              hasFeedback
              /* rules={[
              {
                required: true,
                message: 'Le contenu de la discussion est requis',
              },
            ]} */
            >
              <TextArea
                rows={6}
                placeholder='Entrer le contenu du sujet de discussion ici'
              />
            </Form.Item>

            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                size='large'
                loading={isLoading}
                style={{
                  width: '100%',
                  backgroundColor: ORANGE,
                  borderColor: PRIMARY,
                  borderWidth: 0,
                  marginBottom: 20,
                }}
              >
                Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
